import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';

export const BannerInfoAsignaciones = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA', // Color de fondo muy suave
                borderRadius: 3,
                border: '1px solid #EAEAFF'
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, flex: 1, minWidth: '300px' }}>
                    <Box 
                        sx={{ 
                            width: 52, 
                            height: 52, 
                            borderRadius: '50%', 
                            backgroundColor: '#E8E7FD', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >
                        <AutoAwesomeIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                            ¿Para qué sirve asignar encuestas?
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                            Vincula las encuestas creadas con los dispositivos físicos o virtuales configurados en tu hotel para empezar a recolectar calificaciones.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <LinkOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Conexión Directa
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Enlaza cada dispositivo a un cuestionario específico.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <DeviceHubOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Gestión Centralizada
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Administra todos tus puntos de feedback desde aquí.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <AnalyticsOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', mb: 0.5 }}>
                                Resultados Segmentados
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                Analiza y filtra la información por dispositivo.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
